import Fn from '../../../Modules/Fn.Module'

class focusPoint {
  constructor () {
    this.oTarget = $('#lh-f-p')
    this.bg = this.oTarget.get(0).dataset.bg
    this.oSlick = this.oTarget.find('.lh-f-p-slick')
    this.ytbPlayer = null
    this.oPlayerBox = $('.lh-f-p-player-box')
    this.boxWidth = 1059
    this.bili = 0.65344
    this.pageIndex = 4
    
    //  初始化videoPlay视频
    this.initVideoPlay()
    
    //  监听移入事件
    $(window).on('G2_onLeave', ev => {
      if (ev.nextIndex == this.pageIndex && !window.__focusPointInit) {
        this.init()
      }
      if (ev.nextIndex == this.pageIndex) {
        let el = $('#lh-f-p-player').get(0)
        //  替换链接
        let src = el.src + ' '
        el.src = src
      }
    })
    
    //  加载进入
    if (window.location.hash == '#fourth') {
      if (!window.__focusPointInit) {
        if (window.__fullPageInitEd) {  //  判断fullpage是否已经初始化了
          this.init()
        } else {
          $(window).on('G2_afterRender', ev => this.init())
        }
      }
    }
    
    //  延迟加载
    window.setTimeout(() => {
      !window.__focusPointInit && this.init()
    }, window.gp_load_all)
    
  }
  
  init () {
    window.__focusPointInit = true
    //  监听图片大小
    this.changeResize()
    
    //  渲染背景图片
    Fn.renderImgTag(this.bg).then(() => {
      this.oTarget.css('background-image', `url('${this.bg}')`)
    })
    
    //  初始化html代码
    this.initHtml()
    
    //  this 调用slick
    this.callSlick()
    
    //  初始化canvas老电影效果
    // window.setTimeout(() => {
    //   this.callCanvas()
    // }, 1000)
    
    $(window).resize()
    !window.__isLoaded && window.loadingBar.animate(1)
    
    //  执行动画
    $(window).on('G2_afterLoad', ev => {
      if (ev.index == this.pageIndex) {
        $('.lh-f-p').find('.lh-f-i-title,.lh-f-p-slick-box>div,.focus-point-title').velocity('transition.slideUpBigIn', {
          stagger: 80
        })
      } else {
        $('.lh-f-p').find('.lh-f-i-title,.lh-f-p-slick-box>div,.focus-point-title').css('opacity', 0)
      }
    })
  }
  
  /**
   * 处理老电影的噪点效果
   */
  callCanvas () {
    this.oTarget.find('.lh-f-p-slick').append(`<canvas id="noise" style="position: absolute;top: 24px;left: 24px;"></canvas>`)
    let canvas = document.getElementById('noise')
    let ctx = canvas.getContext('2d')
    let wWidth = this.oTarget.find('.lh-f-p-slick').outerWidth() - 48
    let wHeight = this.oTarget.find('.lh-f-p-slick').outerHeight() - 48
    let noiseData = []
    let frame = 0
    start()
    
    $(window).resize(() => {
      canvas.width = wWidth
      canvas.height = wHeight
      
      
      for (let i = 0 ; i < 10 ; i++) {
        createNoise();
      }
    })
    
    function start () {
      canvas.width = wWidth
      canvas.height = wHeight
      
      
      for (let i = 0 ; i < 10 ; i++) {
        createNoise();
      }
      
      loop();
    }
    
    function createNoise () {
      let idata = ctx.createImageData(wWidth, wHeight);
      let buffer32 = new Uint32Array(idata.data.buffer);
      
      buffer32.map((value, k) => {
        buffer32[k] = Math.random() < 0.5 ? 0xff000000 : 0x22000000
      })
      
      noiseData.push(idata)
    };
    
    function loop () {
      frame++;
      frame = frame < noiseData.length ? frame : 0
      ctx.putImageData(noiseData[frame], 0, 0)
      
      window.requestAnimationFrame(loop);
    };
    
    
  }
  
  /**
   * 调用slick插件
   */
  callSlick () {
    this.oSlick.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 0,
      swipe: false,
      appendArrows: $('.lh-f-p-arrows-box'),
      prevArrow: `<button class="slick-prev n-p js-prev"><img src="${window.gp2_basic_image_path}/focus-point/arrow_left.svg"></button>`,
      nextArrow: `<button class="slick-next n-p js-next"><img src="${window.gp2_basic_image_path}/focus-point/arrow_right.svg"></button>`,
      dots: true,
      rtl: window.gp2_is_rtl,
      appendDots: $('.lh-f-p-dots-box'),
    })
    
    this.oSlick.on('afterChange', (ev, slick, currentSlide) => {
      let item = this.oTarget.find('.slick-active').get(0)
      if (!item.dataset.videoId) {
        if (this.ytbPlayer) {
          //  todo  这里有问题
          this.ytbPlayer.pauseVideo()
        }
        return false
      }
      
      this.setPlayerPosition(item)
      
      this.changeVideo(item.dataset.videoId)
    })
    
  }
  
  /**
   * 初始化部分html代码
   */
  initHtml () {
    //  初始化slide代码
    this.oTarget.find('.item-slide').map((index, el) => {
      let img = el.dataset.img
      let imgMb = el.dataset.imgMb
      $(el).append(`<img src="${img}" class="lh-f-p-bg visible-lg" />`)
      $(el).append(`<img src="${imgMb}" class="lh-f-p-bg-mb hidden-lg" />`)
    })
    
    //  初始化arrows + dots代码
    this.oTarget.find('.lh-f-p-wrap').append(`<div class="lh-f-p-arrows-box"></div>`)
    this.oTarget.find('.lh-f-p-wrap').append(`<div class="lh-f-p-dots-box"></div>`)
  }
  
  /**
   * 初始化播放器
   */
  initVideoPlay () {
    if (window.__ytbIsReady == true) {
      this._initVideoPlay()
    } else {
      $(window).on('onYouTubeIframeAPIReady', () => {
        this._initVideoPlay()
      })
    }
  }
  
  _initVideoPlay () {
    //  获取当前播放切换slick item 的数据
    let item = this.oTarget.find('.item-slide').get(0)
    //  计算宽高
    let iWidth = item.dataset.videoWidth
    let iHeight = iWidth * 0.5625
    let y = item.dataset.videoY
    let x = item.dataset.videoX
    
    let newPosition = {
      'width': iWidth,
      'height': iHeight,
      'y': y,
      'x': x
    }
    if (window.innerWidth < window.gp_max_md) {
      newPosition = this.getMobilePosition(newPosition)
    }
    
    //  计算宽高
    let id = item.dataset.videoId
    this.oPlayerBox.css({
      top: newPosition.y + 'px',
      left: newPosition.x + 'px'
    })
    
    this.ytbPlayer = new YT.Player('lh-f-p-player', {
      height: newPosition.height,
      width: newPosition.width,
      playerVars: {
        'autoplay': 1,
        'controls': 0,
        'rel': 0,
        'showinfo': 0,
        'modestbranding': 1,
        'loop': 1,
        'mute': 1,
        'playlist': id
        // 'iv_load_policy': 3,
        // 'wmode': 'transparent',
        // 'enablejsapi': 1
      },
      suggestedQuality: 'hd1080',
      videoId: id,
      events: {
        'onReady': () => this.ytbPlayer.mute(),
        'onStateChange':
          event => {
            if (event.data === 0) {
              this.ytbPlayer.seekTo(0)
            }
          }
      }
    })
    
    
    //  处理页面拖动出现滚动条后内容被刷新问题
    $(window).resize(() => {
      window.setTimeout(() => {
        if(!B.isMobile()){
          let el = $('#lh-f-p-player').get(0)
          //  替换链接
          let videoid = el.src.match(/embed\/(.*?)\?/)[1]
          let src = `https://www.youtube.com/embed/${videoid}?autoplay=1&controls=0&rel=0&showinfo=0&modestbranding=1&enablejsapi=1&widgetid=1&mute=1&loop=1&playlist=${videoid}`
          el.src = src
        }
      }, 500)
    })
  }
  
  /**
   * 切换视频
   * @param id
   */
  changeVideo (id) {
    if (this.ytbPlayer) {
      let el = $('#lh-f-p-player').get(0)
      //  替换链接
      let src = `https://www.youtube.com/embed/${id}?autoplay=1&controls=0&rel=0&showinfo=0&modestbranding=1&enablejsapi=1&widgetid=1&mute=1&loop=1&playlist=${id}`
      el.src = src
    }
  }
  
  /**
   * 设置播放器位置
   * @param el
   */
  setPlayerPosition (el) {
    //  计算宽高
    let iWidth = 679
    let iHeight = iWidth * 0.5625
    let y = 230
    let x = 67
    
    let newPosition = {
      'width': iWidth,
      'height': iHeight,
      'y': y,
      'x': x
    }
    if (window.innerWidth < 1700) {
      newPosition = this.getMobilePosition(newPosition)
    }
    
    if (window.innerWidth < window.gp_max_md) { //  平板以下
      newPosition = this.getMobileRealPosition(newPosition)
    }
    
    if (980 < window.innerWidth && window.innerWidth < window.gp_max_md) {
      newPosition = {
        'width': 550,
        'height': 550 * 0.5625,
        'y': 62,
        'x': 25
      }
    }
    
    this.oPlayerBox.css({
      top: newPosition.y + 'px',
      left: newPosition.x + 'px'
    })
    
    this.ytbPlayer && this.ytbPlayer.setSize(newPosition.width, newPosition.height)
  }
  
  /**
   * 获取移动端播放器位置 1700
   * @param newPosition
   * @returns {*}
   */
  getMobilePosition (newPosition) {
    let width = window.innerWidth
    if (window.gp_max_md < window.innerWidth && window.innerWidth < 1700) {
      width = 800
    }
    
    newPosition.width = newPosition.width * width / this.boxWidth
    newPosition.height = newPosition.width * 0.5625
    newPosition.x = newPosition.x * width / this.boxWidth
    newPosition.y = (newPosition.y * width * this.bili / (this.boxWidth * this.bili)) + 3
    
    if (window.innerWidth < 480) {
      newPosition.y += window.innerWidth * 0.02
    }
    
    return newPosition
  }
  
  
  /**
   * 获取移动端播放器位置 平板一下
   * @param newPosition
   * @returns {*}
   */
  getMobileRealPosition (newPosition) {
    let width = window.innerWidth
    
    newPosition.width = width * 0.768
    newPosition.height = newPosition.width * 0.5625
    newPosition.x = 14
    newPosition.y = 58
    
    if (window.innerWidth < 768) {
      newPosition.width = window.innerWidth * 0.96
      newPosition.height = newPosition.width * 0.5625
      newPosition.x = 14 * window.innerWidth / 790
      newPosition.y = 63 * window.innerWidth / 580
    }
    
    if (window.innerWidth < 454) {
      newPosition.y = 70 * window.innerWidth / 580
    }
    
    return newPosition
  }
  
  /**
   * 监听浏览器拖拽事件
   */
  changeResize () {
    $(window).resize(() => {
      let width = this.boxWidth
      if (window.innerWidth < window.gp_max_md) {
        width = window.innerWidth
      } else if (window.innerWidth < 1700) {
        width = 800
      }
      
      if (window.innerWidth < window.gp_max_md) {
        width = window.innerWidth * 0.8
        
        if (window.innerWidth > 980) {
          width = 600
        }
      }
      
      if (window.innerWidth < 768) {
        width = window.innerWidth
      }
      
      let height = this.bili * width
      if (window.innerWidth < window.gp_max_md) {
        height = 0.95 * width
      }
      if (window.innerWidth < 768) {
        // height = 1 * width
        height = 'auto'
      }
      
      $('.lh-f-p-slick-box').css({
        width: width,
        height: height
      })
      
      //  处理当前盒子的位置
      let item = this.oTarget.find('.slick-active').get(0)
      if (!item || !item.dataset.videoId) {
        return false
      }
      this.setPlayerPosition(item)
    })
  }
}

export default focusPoint